import moment from "moment";

export const formatDate = (data, format) => {
  return moment(data).format(format);
};
